module.exports = __webpack_public_path__ + "static/media/cpl.7e27ba71.png";